import React from 'react'
import { observer } from 'mobx-react'
import { productMobx, restaurantConfig } from 'restaurant'
import { ConfirmModal } from '@cps'
import { ProductImage } from 'components'
import './index.scss'

interface IProps {
  title?: React.ReactNode | string;
  cancelText?: string;
  confirmText?: string;
  errData: any[];
  hideCancel?: boolean;
  type?: 'saleOut' | 'supplyStock'; // 停限售 ｜ 供应链物料不足
}

const SoldOutModal: React.FC<IProps> = (props) => {
  const { title, errData, hideCancel = false, cancelText, confirmText, type = 'saleOut' } = props

  // 停限售
  const renderSaleOut = () => {
    return errData?.map((item: any) => {
      return (
        <div className='soldout-product-item' key={item.productNo + item.scaleNo}>
          <ProductImage color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={40} imgSrc={item.pic} />
          <div className='product-name'>
            <strong>{item.productName || item.name}</strong>
            <div className='product-option'>{item.optionStr}</div>
          </div>
        </div>
      )
    })
  }

  // 供应链物料不足
  const renderSupplyStock = () => {
    return (
      <>
        {errData.map((item: any, index: number) => {
          const viewProduct = item.productType === 'product' ? productMobx.noToViewProductMap[item.productNo] : productMobx.modifierNoToModifierMap[item.productNo]
          const viewSale = item.productType === 'product' && viewProduct ? (viewProduct as IViewProduct).scales?.find(sale => sale.no === item.scaleNo) : {} as IScale
          return (
            <div className='supply-stock-item' key={item.productNo + item.scaleNo}>
              {
                viewSale?.name ? (
                  <div>
                    {index !== 0 && <span>{i18n.t('common.or')}</span>}
                    <span className='product-name'>{viewProduct.name}</span>
                    <span className='scale-name'>{viewSale?.name}</span>
                  </div>
                ) : (
                  <div>
                    {index !== 0 && <span>{i18n.t('common.or')}</span>}
                    <span className='product-name'>{viewProduct.name}</span>
                  </div>
                )
              }
              <span>{item.cnt}</span>
            </div>
          )
        })}
        <p className='supply-stock-tips'>{i18n.t('cart.newSupplyStockWarnTips')}</p>
      </>
    )
  }

  return (
    <ConfirmModal
      title={title || (type === 'supplyStock' ? i18n.t('cart.newSupplyStockWarn') : i18n.t('cart.saleWarn'))}
      cancelText={type !== 'supplyStock' && !hideCancel && (cancelText || i18n.t('newCart.continueAdd'))}
      confirmText={confirmText || i18n.t('cart.ikonw')}
      children={(
        <div className='soldout-product-list'>
          {type === 'supplyStock' ? renderSupplyStock() : renderSaleOut()}
        </div>
      )}
      className='soldout-warn-modal'
    />
  )
}

export default observer(SoldOutModal)
